<template>
  <div class="action copy-amazon-link" @click="copyLink">View On Amazon</div>
</template>

<script>
export default {
  name: "ViewReviewOnAmazon",
  props: ["assignment"],
  methods: {
    copyLink() {
      const link = this.assignment.review ? this.assignment.review.url : '';
      const command = isMacintosh() ? "Command+V" : "Ctrl+V";

      let message = "";

      if (link.indexOf("http") !== -1) {
        message =
          "Your Amazon link is ready! Open a new tab and paste (" +
          command +
          ") into the search box to view the book.";
      } else {
        message =
          "Opps! Something wen't wrong"
      }

      this.$toasted.show(message, {
        icon: "link",
        position: "bottom-center",
        duration: 6000
      });

      copyToClipboard(link);
    },
    handleClick() {
      this.copyLink();
    }
  }
};

function isMacintosh() {
  return navigator.platform.indexOf("Mac") > -1;
}

function copyToClipboard(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    // IE specific code path to prevent textarea being shown while dialog is visible.
    return clipboardData.setData("Text", text);
  } else if (
    document.queryCommandSupported &&
    document.queryCommandSupported("copy")
  ) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand("copy"); // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn("Copy to clipboard failed.", ex);
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }
}
</script>

<style lang="scss" scoped>
.action {
  display: inline-block;
}
.copy-amazon-link {
  margin: 0;
  margin-top: -6px;
  font-size: 10.5pt !important;
}
</style>



